import { render } from "./AuthBtnsComponent.vue?vue&type=template&id=9eceff8a&scoped=true"
import script from "./AuthBtnsComponent.vue?vue&type=script&lang=js"
export * from "./AuthBtnsComponent.vue?vue&type=script&lang=js"

import "./AuthBtnsComponent.vue?vue&type=style&index=0&id=9eceff8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eceff8a"]])

export default __exports__